<template>
	<StandardModal
		open
		small
		:title="$t('settings_apitokens_max_number')"
		@cancel="$emit('cancel')"
	>
		<div class="max-tokens">
			<ExclaimBackgroundIcon class="tokens-logo" />

			<div class="help">
				{{ $t('settings_apitokens_max_number_help') }}
			</div>
		</div>
		<template #footer-right>
			<Button primary @click="$emit('next')">
				{{ $t('common_button_okay') }}
			</Button>
		</template>
	</StandardModal>
</template>

<script>
import { StandardModal, Button } from '@/components/common'
import { ExclaimBackgroundIcon } from '@/icons'

export default {
	components: { ExclaimBackgroundIcon, StandardModal, Button },
	emits: ['next', 'cancel']
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.max-tokens {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	.tokens-logo {
		width: 230px;
		height: 107px;
		margin: 50px 0 65px 0;
	}

	.help {
		font-family: 'Avenir-Medium';
		font-size: 18px;
		color: var(--neutral-600);
		width: 400px;
	}
}
</style>
